/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('ProfileService', ProfileService);

  ProfileService.$inject = ['$resource'];

  function ProfileService ($resource) {
    return $resource('', {}, {
      getAll: { url: apiUrl + '/profiles/getAll', method: 'GET', params: {}, isArray: false },
      search: { url: apiUrl + '/profiles/search', method: 'GET', params: {}, isArray: false },
      insert: { url: apiUrl + '/profiles/insert', method: 'POST', params: {}, isArray: false },
      update: { url: apiUrl + '/profiles/update', method: 'POST', params: {}, isArray: false },
      delete: { url: apiUrl + '/profiles/delete', method: 'POST', params: {}, isArray: false },
      getAllNotPaginated: { url: apiUrl + '/profiles/getAllNotPaginated', method: 'GET', params: {}, isArray: true },
      syncPermissions: { url: apiUrl + '/profiles/syncPermissions', method: 'POST', isArray: false },
      getStatus: { url: apiUrl + '/profiles/getStatus', method: 'GET', params: {}, isArray: true },
      getSectors: { url: apiUrl + '/profiles/getSectors', method: 'GET', params: {}, isArray: true },
      getProfilesHierarchy: {url: apiUrl + '/profiles/getProfilesHierarchy', method: 'GET', params: {}, isArray: false},
      getModalProfileHierarchy: {url: apiUrl + '/profiles/getModalProfileHierarchy', method: 'GET', params: {}, isArray: false},
      editProfilesHierarchy: {url: apiUrl + '/profiles/editProfilesHierarchy', method: 'POST', params: {}, isArray: false},
      getTransferSectors: { url: apiUrl + '/profiles/getTransferSectors', method: 'GET', params: {}, isArray: true }
    })
  }
})();
